import axios from 'axios';
import {get_headers, COUNT_SUB_ENTITIES_URL, LIST_SUB_ENTITIES_BY_PARENT_APPLICATION} from '@/utils/constants/constants';
import alert_mixin from "@/utils/mixins/alert_mixin";

export default {
  name: "BeneficiaryRegister",
  mixins: [alert_mixin],
  data: () => ({
      activeTab: "All",
      search: "",

      tabs: ["All", "Active", "Inactive", "Pending"],


      beneficiaries: [
        // { id: 1, initials: "SN", name: "Sipho Ndlovu", idNumber: "****1234", startDate: "2023-06-10", status: "Active", kyc: "Pending", allocation: 1.2, distributed: 45320 },
        // { id: 2, initials: "TN", name: "Thandi Ngcobo", idNumber: "****5678", startDate: "2023-01-15", status: "Active", kyc: "Approved", allocation: 1.5, distributed: 67500 },
        // { id: 3, initials: "BZ", name: "Bongani Zulu", idNumber: "****9012", startDate: "2023-03-20", status: "Active", kyc: "Approved", allocation: 1.0, distributed: 38200 },
        // { id: 4, initials: "NK", name: "Nomsa Khumalo", idNumber: "****3456", startDate: "2024-02-01", status: "Active", kyc: "Pending", allocation: 0.8, distributed: 12500 },
        // { id: 5, initials: "MS", name: "Mandla Sithole", idNumber: "****7890", startDate: "2023-09-15", status: "Inactive", kyc: "Rejected", allocation: 1.0, distributed: 25000 },
        // { id: 6, initials: "ZM", name: "Zanele Mbeki", idNumber: "****2345", startDate: "2023-07-01", status: "Active", kyc: "Approved", allocation: 1.3, distributed: 52100 }
      ],
      is_loading_stats: false,
      is_loading_beneficiaries: false,
      sub_entity_stats: {
        total: 0,
        active: 0
      }
  }),

    mounted() {
      this.fetch_sub_entity_stats();
      this.fetch_sub_entities();
    },


  computed: {
    stats() {
    return [
      { label: "Total Beneficiaries", value: this.sub_entity_stats.total },
      { label: "Active", value: this.sub_entity_stats.active, colorClass: "text-emerald-500" },
      { label: "Pending KYC", value: 3, colorClass: "text-orange-400" },
      { label: "Fully Verified", value: 3 }
    ];
  },
    filteredBeneficiaries() {
      let list = this.beneficiaries;

      // Filter by tab
      if (this.activeTab !== "All") {
        list = list.filter(
          b =>
            b.status === this.activeTab ||
            b.kyc === this.activeTab
        );
      }

      // Filter by search
      if (this.search) {
        const searchLower = this.search.toLowerCase();
        list = list.filter(b =>
          b.name.toLowerCase().includes(searchLower)
        );
      }

      return list;
    }
  },

  methods: {
    formatCurrency(value) {
      return value.toLocaleString();
    },

    fetch_sub_entity_stats() {
      const entity_profile_id = sessionStorage.getItem('entity_profile_id');
      if (!entity_profile_id) return;

      this.is_loading_stats = true;

      axios.get(COUNT_SUB_ENTITIES_URL, {
        headers: get_headers(),
        params: { entity_profile_id },
      })
        .then((response) => {
          if (response.data?.status === 'success') {
            this.sub_entity_stats.total = response.data.sub_entity_count || 0;
            this.sub_entity_stats.active = response.data.active_sub_entity_count || 0;
          }
        })
        .catch((err) => {
          this.show_error('Failed to load beneficiary stats: ' + err.message);
        })
        .finally(() => {
          this.is_loading_stats = false;
        });
    },

    fetch_sub_entities() {
      const parent_application_id = sessionStorage.getItem('application_id');
      const entity_profile_id = Number(sessionStorage.getItem('entity_profile_id') || 0);

      if (!parent_application_id) return;

      this.is_loading_beneficiaries = true;
      const params = { parent_application_id: Number(parent_application_id) };
      if (entity_profile_id > 0) params.entity_profile_id = entity_profile_id;

      axios.get(LIST_SUB_ENTITIES_BY_PARENT_APPLICATION, {
        headers: get_headers(),
        params,
      })
        .then(res => {
          const body = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;

          if (body?.status !== 'success') {
            this.show_error(body?.message || 'Failed to load beneficiaries.');
            return;
          }

          const sub_entities = Array.isArray(body?.data)
            ? body.data : (body?.data?.children || []);

          // Map to beneficiary shape that matches the table columns
          this.beneficiaries = sub_entities.map((child) => {
            const form = Array.isArray(child.forms) ? child.forms[0] : null;
            const name = child.name || 'Unknown';
            const initials = name.split(' ').slice(0, 2).map(w => w[0]?.toUpperCase() || '').join('');

            return {
              id: child.id,
              initials,
              name,
              idNumber: child.id_number || '—',
              startDate: form?.date_created
                ? new Date(form.date_created).toLocaleDateString('en-ZA', {
                    day: 'numeric', month: 'short', year: 'numeric'
                  })
                : '—',
              status: child.status || 'Pending',
              kyc: child.kyc_status || 'Pending',
              allocation: child.allocation || 0,
              distributed: child.distributed || 0,
            };
          });
        })
        .catch(err => {
          this.show_error('Failed to load beneficiaries: ' + (err.response?.data?.message || err.message));
        })
        .finally(() => {
          this.is_loading_beneficiaries = false;
        });
    }
  }
};